// tslint:disable:no-any
// tslint:disable:max-line-length
// tslint:disable:jsx-no-string-ref
import React, { Component } from 'react';
import { Redirect } from 'react-router';
import ReactDOM from 'react-dom';
import validator from 'validator';
import { AuthLock } from '../auth/AuthLock';
import Footer from '../components/Footer';
import RegistrationModal from '../components/RegistrationModal';
import MessageModal from '../components/MessageModal';
import CookieConsent from '../components/CookieConsent';
import PublicHeader from '../components/PublicHeader';
import { getExpirateMessage } from '../components/Message';
import { ProfileService } from '../services/ProfileService';
import { BASE_PATH } from '../api';
import WetnotesLogo from '../components/WetnotesLogo';
// import { AuthLogic } from '../auth/AuthLogic';

export interface IHomePageProps {
  location: any;
}

interface IHomePageState {
  newsletterEmail: string;
  navRightClassName: string;
  slides: any;
  registrationModal: boolean;
  message: any;
  messageType: any;
  redirectToHomePage: boolean;
  redirectToDashboard: boolean;
}

class HomePage extends Component<IHomePageProps, IHomePageState> {
  static setMessage(text: string, type: any) {
    localStorage.setItem('message', text);
    localStorage.setItem('messageType', type);
    localStorage.setItem('messageExpirate', getExpirateMessage() as any);
  }

  constructor(props: IHomePageProps) {
    super(props);

    this.state = {
      newsletterEmail: '',
      navRightClassName: 'hidden',
      slides: [
        {
          slide: 1,
          heading: 'this is awesome',
          name: 'John Wick',
                    text:
                        'Nostra suspendisse viverra mollis maecenas etiam at malesuada vehicula a iaculis et accumsan felis taciti parturient adipiscing.Porta diam at vestibulum dui vitae montes rutrum fames parturient consectetur magnis penatibus sit tellus curabitur urna mi velit in potenti.Pharetra sem malesuada scelerisque condimentum a a a ante cubilia libero facilisis litora a parturient elit.Ullamcorper lacus bibendum ornare scelerisque consectetur pharetra dignissim a sodales aenean nullam praesent parturient aenean odio aenean a montes non nascetur eget nam elit fermentum taciti praesent consectetur.Class nascetur suscipit viverra est fermentum a a etiam sem scelerisque leo lacinia suspendisse parturient aliquet.'
        },
        {
          slide: 2,
          heading: 'this is event better',
          name: 'John Dive',
                    text:
                        'A posuere ullamcorper parturient nisi conubia mus justo hac a scelerisque a convallis vulputate a vestibulum cras nulla in nam scelerisque parturient sem vestibulum aliquet ultrices libero elit nisi morbi.A non mauris parturient maecenas proin justo a a dui vestibulum a nisi fringilla erat suspendisse suspendisse ad ullamcorper nec a lectus.A scelerisque vulputate ultricies lectus dignissim adipiscing accumsan faucibus condimentum lacus scelerisque condimentum per platea.'
        },
        {
          slide: 3,
          heading: 'I love it',
          name: 'Bryan Adams',
                    text:
                        'Velit dui euismod justo ante suspendisse fusce hendrerit quisque sodales lobortis maecenas gravida aliquet mollis ac per fermentum a condimentum ad maecenas at proin suscipit at nunc neque a.Ultricies turpis mattis neque per fermentum habitasse a nibh suspendisse a a a a eu ad nisl convallis pretium suspendisse a nibh vestibulum ut.Euismod torquent vestibulum vestibulum elit hendrerit quisque magnis quis viverra consequat scelerisque velit justo ultricies eu facilisi commodo nisl suspendisse aptent bibendum a.'
        }
      ],
      // zobrazeni registracniho modalu
      registrationModal: false,
      // hlaska do modalu
      message: null,
      messageType: null,
      // presmery
      redirectToHomePage: false,
      redirectToDashboard: false
    };
  }

  async componentDidMount() {
    // scrollTo
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.scrollTo
    ) {
      this.scrollTo(this.props.location.state.scrollTo);
    } else {
      window.scrollTo(0, 0);
    }

    // title
    document.title = 'WetNotes | The online home for all divers';

    // message
    if (
      localStorage.getItem('message') !== null &&
      localStorage.getItem('messageExpirate') !== null
    ) {
      const expirate = localStorage.getItem('messageExpirate');
      if (expirate !== null && new Date(expirate) > new Date()) {
        this.setState({
          message: localStorage.getItem('message'),
          messageType: localStorage.getItem('messageType')
        });
      }
    }

    // vycistim localStorage
    this.clearMessageInStorage();

    // not registered
    if (
      this.props.location &&
      this.props.location.search &&
      this.props.location.search === '?NotRegistered'
    ) {
      const profile = await ProfileService.getInstance().reloadProfile();
      if (profile == undefined) {
        return;
      }
      const temp = profile as Response;
      if (temp == undefined) {
        this.setRedirectToDashboard();
      } else if (temp && (temp as any).config) {
        this.setRedirectToDashboard();
      } else {
        const data = await temp.json();
        if (data.errorText === 'NotRegistered') {
          this.setState({
            registrationModal: true
          });
        } else {
          this.setRedirectToHomePage();
        }
      }
    }
  }

  clearMessageInStorage() {
    localStorage.removeItem('message');
    localStorage.removeItem('messageType');
    localStorage.removeItem('messageExpirate');
  }

  setMessage(text: string, type: string) {
    this.setState({
      message: text,
      messageType: type
    });
  }

  onCloseMessage() {
    this.setState(
      {
        message: null,
        messageType: null
      },
      () => {
        // vycistim localStorage
        this.clearMessageInStorage();
      }
    );
  }

  setRedirectToHomePage() {
    this.setState({
      redirectToHomePage: true
    });
  }

  setRedirectToDashboard() {
    this.setState({
      redirectToDashboard: true
    });
  }

  sliderRight() {
    var slides = this.state.slides;
    var newSlides = slides.slice(-1).concat(slides.slice(0, -1));
    this.setState({
      slides: newSlides
    });
  }

  sliderLeft() {
    var slides = this.state.slides;
    var newSlides = slides.slice(1).concat(slides.slice(0, 1));
    this.setState({
      slides: newSlides
    });
  }

  scrollTo(refName: any) {
    window.scrollBy(
      0,
            ReactDOM.findDOMNode(this.refs[refName]).getBoundingClientRect()
                .top - 68
    );
  }

  doAuthSign() {
    AuthLock.getInstance().showSignUp();
    // AuthLogic.getInstance().renew();
  }

  onChangeNewsletterEmail(event: any) {
    this.setState({
      newsletterEmail: event.target.value
    });
  }

  onSubmitNewsletterEmail() {
    // @TODO: validace emailu
    if (this.state.newsletterEmail !== '') {
      // validace emailu
      if (!validator.isEmail(this.state.newsletterEmail)) {
        alert('Please enter valid email');
      } else {
        // data pro api
        let data = JSON.stringify({
          email: this.state.newsletterEmail
        });

        fetch(BASE_PATH + '/newsletter', {
          method: 'POST',
          body: data
                })/*.then(res => res.json())*/.then(res => {
            if (res.status === 400) {
              alert((res as any).errorText);
            }
            // done
            // @TODO: fix it
            // if (res.status === 201) {
            // vynulovani
            this.setState(
              {
                newsletterEmail: ''
              },
              () => {
                            this.setMessage(
                                'Your email has been added',
                                'Success'
                            );
              }
            );
          });
      }
    }
  }

  render() {
    return (
      <div className="homepage">
                <PublicHeader scrollTo={e => this.scrollTo(e)} />

        {this.state.message !== null && (
          <MessageModal
            type={this.state.messageType}
            text={this.state.message}
            onClose={() => this.onCloseMessage()}
          />
        )}

        <section ref="home" className="section--hero">
          <div className="wrapper">
            <div className="section--hero__holder sm-hidden">
              <div className="section--hero__holder__item">
                <h1>
                  <WetnotesLogo color="red" />
                  <span>
                                        Your personal ticket<br />to the world
                                        of diving.
                  </span>
                </h1>
                <p>
                                    WetNotes is a place where professional and
                                    recreational divers can plan, analyze and
                                    share their dives with others. Enjoy this
                                    easy to use and most modern tool available.
                </p>
                <a
                  onClick={this.doAuthSign}
                  className="btn btn--pill btn--borderRed "
                >
                  SIGN UP
                </a>
              </div>
            </div>

            <div className="section--hero__holder__mobile sm-visible">
              <div className="section--hero__holder__mobile__item">
                <h1>
                  <span>WetNotes.</span>
                  <br />
                  <span>
                                        Your personal ticket<br />to the world
                                        of diving.
                  </span>
                </h1>
                <p>
                                    WetNotes is a place where professional and
                                    recreational divers can plan, analyze and
                                    share their dives with others. Enjoy this
                                    easy to use and most modern tool available.
                </p>
                <a
                  onClick={this.doAuthSign}
                  className="btn btn--pill btn--borderRed "
                >
                  SIGN UP
                </a>
              </div>

              <div className="section--hero__holder__item" />
            </div>
          </div>
        </section>

        <section ref="howto" className="section section--howItWorks">
          <div className="wrapper">
                        <h2 className="homepage__sectionHeading small">
                            How it works
                        </h2>
            <p className="homepage__sectionText">
                            Welcome to WetNotes. Your best online tool for
                            managing your dives.<br />
                            This site was created by divers for divers so we
                            believe you will truly enjoy it. Just follow these
                            four simple steps to get the most out of it.
            </p>

            <div className="section--howItWorks__item">
              <div className="section--howItWorks__item__img section--howItWorks__item__img--step-1">
                <div>1</div>
              </div>
              <h3>UPLOAD YOUR DIVES</h3>
              <p>
                                You have the possibility to keep track of each
                                dive you make. All you must do is upload
                                essential information from your deco computer or
                                rebreather. Store your gas management, ascent
                                and decompression data online where you will be
                                able to analyze your dive easily.
              </p>
            </div>

            <div className="section--howItWorks__item">
              <div className="section--howItWorks__item__img section--howItWorks__item__img--step-2">
                <div>2</div>
              </div>
              <h3>ANALYZE DATA</h3>
              <p>
                                With WetNotes you can analyze and monitor the
                                performance indicator of your deco computer or
                                rebreather in detail and from the comfort of
                                your home. After uploading your dive logs, a
                                collection of easy-to-navigate charts will be
                                immediately available. It’s that easy.
              </p>
            </div>

            <div className="section--howItWorks__item">
              <div className="section--howItWorks__item__img section--howItWorks__item__img--step-3">
                <div>3</div>
              </div>
              <h3>SHARE WITH OTHERS</h3>
              <p>
                                Your friends and colleagues want to know about
                                your diving experiences. They want to know where
                                you dive and what results you have achieved.
                                Share your skills and know-how with others just
                                by clicking a button!
              </p>
            </div>

            <div className="section--howItWorks__item">
              <div className="section--howItWorks__item__img section--howItWorks__item__img--step-4">
                <div>4</div>
              </div>
              <h3>ENJOY THE COMMUNITY</h3>
              <p>
                                Check out your friends' profiles, get inspired,
                                get motivated, get better results next time.
                                Explore more diving locations and tell your
                                friends where you have been. Everybody likes to
                                brag a little bit. We want you to do it right
                                here!
              </p>
            </div>
          </div>
        </section>

        <section ref="wetnotes" className="section section--unnamed">
          <div className="wrapper">
            <h2 className="homepage__sectionHeading small">
              Our solution to your diving needs
            </h2>
            <p className="homepage__sectionText">
                            We are providing you with a modern, easy-to-use and
                            responsive user interface which you can access on
                            your computer, mobile phone or tablet. No need to
                            install any applications – every function is
              accessible right from your browser.
            </p>

            <div className="text-center">
              <div
                onClick={this.doAuthSign}
                className="btn btn--smallpill btn--colorRed btn--borderRed"
              >
                Sign up
              </div>
            </div>

            <div className="application">
              <div className="img" />
            </div>
          </div>
        </section>

        <section
            ref="testimonials"
            className="section section--testimonials"
        >
          <div className="wrapper">
            <div className="hidden">
                            <h2 className="homepage__sectionHeading small">
                                Testimonials
                            </h2>
              <p className="homepage__sectionText">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Vivamus euismod leo id
                                efficitur tempor.
              </p>

              <div className="testimonialsSlider">
                <div className="testimonialsSlider__holder">
                  <div
                    className="testimonialsSlider__arrow--left testimonialsSlider__arrow"
                    onClick={() => this.sliderLeft()}
                  />
                  <div
                    className="testimonialsSlider__arrow--right testimonialsSlider__arrow"
                    onClick={() => this.sliderRight()}
                  />

                  {/*TODO ASK DUSSAN*/}
                  <div className="testimonialsSlider__imgHolder">
                    {this.state.slides.map(
                        (slide: any, index: number) => (
                      <div
                        key={index}
                        className={`testimonialsSlider__img testimonialsSlider__img--${
                            slide.slide
                        }`}
                      >
                        <img
                          src={require(`../assets/img/face${
                              slide.slide
                          }.png`)}
                          alt=""
                        />
                      </div>
                                            )
                                        )}
                  </div>
                </div>

                <h4>{this.state.slides[1].heading}</h4>

                <p>{this.state.slides[1].text}</p>

                <p>{this.state.slides[1].name}</p>
              </div>
            </div>
          </div>
        </section>

        <section
            ref="numbers"
            className="section section--numbers hidden"
        >
          <div className="section--numbers__filter" />
          <div className="wrapper">
            <h2 className="homepage__sectionHeading small">
              WetNotes in Numbers
            </h2>

            <div className=" section--numbers__item">
              <p>12456</p>
              <p>users now</p>
            </div>

            <div className=" section--numbers__item">
              <p>3 117</p>
              <p>location for diving</p>
            </div>

            <div className=" section--numbers__item">
              <p>70</p>
              <p>diving logs every day</p>
            </div>

            <div className=" section--numbers__item">
              <p>1 452</p>
              <p>new friendships</p>
            </div>
          </div>
        </section>

        <section
            ref="newsletters"
            className="section section--newsletter"
        >
          <div className="wrapper">
            <div className="section--newsletter__text">
              <h3>WetNotes Newsletter</h3>
              <p>
                                Even at this very minute we are working on new
                                features, soon available to everyone to make the
                                most of your dives. Sign up for our newsletter
                                and never miss the new cool stuff we have
                planned for you!
              </p>
            </div>

            <div className="section--newsletter__form">
              <p>YOUR E-MAIL</p>
              <div className="section--newsletter__form__input">
                <a
                  href="https://mail.divesoft.com/newsletter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <input
                    type="text"
                    placeholder="Your e-mail"
                    readOnly
                  />
                  <div>SIGN UP</div>
                </a>
              </div>
              <p>
                By entering your e-mail address you agree with
                receiving marketing e-mails regarding WetNotes.
                You can unsubscribe at any time!
              </p>
            </div>
          </div>
        </section>

                {this.state.registrationModal === true &&
                    <RegistrationModal display={true} />}

                {this.state.redirectToHomePage === true &&
                    <Redirect to="/" />}

                {this.state.redirectToDashboard === true &&
                    <Redirect to="/app" />}

        <Footer ref="footer" logged={false} />

        <CookieConsent />
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/HomePage.tsx